// Display numbers for a questionnaire: top-level questions count 1, 2, 3, ... and a conditional
// follow-up takes its parent's number plus a letter (168 -> 168a, 168b, ...), so revealing
// follow-ups never renumbers the questions after them. A follow-up of a follow-up gets a dotted
// index (168a.1, 168a.2). `questions` must be in display order with each parent before its
// children (orderQuestionsWithChildren guarantees this); a question whose parent is not in the
// list is numbered as a top-level question.

function letterSuffix(n) {
    // 1 -> a, 26 -> z, 27 -> aa
    let s = '';
    while (n > 0) {
        const r = (n - 1) % 26;
        s = String.fromCharCode(97 + r) + s;
        n = Math.floor((n - 1) / 26);
    }
    return s;
}

// Returns a Map of question id -> display label (string).
export function buildQuestionNumbers(questions, idField) {
    const labels = new Map();
    const depth = new Map();
    const childCount = new Map();
    let rootCount = 0;

    (questions || []).forEach(q => {
        const id = q[idField];
        const pid = q.parentQuestionId;
        if (pid != null && pid !== id && labels.has(pid)) {
            const n = (childCount.get(pid) || 0) + 1;
            childCount.set(pid, n);
            const parentDepth = depth.get(pid);
            labels.set(id, parentDepth === 0 ? `${labels.get(pid)}${letterSuffix(n)}` : `${labels.get(pid)}.${n}`);
            depth.set(id, parentDepth + 1);
        } else {
            rootCount += 1;
            labels.set(id, String(rootCount));
            depth.set(id, 0);
        }
    });

    return labels;
}

// Number of top-level questions in a list numbered by buildQuestionNumbers.
export function countTopLevelQuestions(labels) {
    let count = 0;
    labels.forEach(label => { if (/^\d+$/.test(label)) count += 1; });
    return count;
}
